import React from "react";
import { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import "../../laturmap/laturmap.scss";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import no_photo from "../../../assets/no-photo.webp"

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";

import "react-accessible-accordion/dist/fancy-example.css";

function Accordian({ selectedVillage }) {

 
    return (
        <>
            <Accordion>
                {
                   selectedVillage && selectedVillage.map((item, index) => (
                        <AccordionItem key={index}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    {item.sector_name}
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>


                              {
                                item.images && item.images.length > 0 ?   <Swiper
                                spaceBetween={30}
                                centeredSlides={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    clickable: true
                                }}
                                navigation={true}
                                modules={[Autoplay, Pagination, Navigation]}
                                className="mySwiper"
                            >

                               {
                                item.images && item.images.map((img, index)=>(
                                    <SwiperSlide>

                                    <div className="work_img bg-img-contain"  style={{backgroundImage:`url(https://diwise.cloud/spn_images/${img})`}} >

                                    </div>







                                </SwiperSlide>
                                ))
                               }

                            </Swiper>
                            :
                            <div className="no_photo work_img bg-img-contain"  style={{backgroundImage:`url(${no_photo})`}} >

                            </div>
                              }
                                <div className="work_details">
                                   { item.start_date && <div className="rakkam btn">
                                    दिनांक : {item.start_date.slice(0,4)}
                                    </div>}
                                    {item.sector_name && <div className="rakkam btn">
                                    छेत्र :  {item.sector_name}
                                    </div>}
                                    {item.work_budget && <div className="rakkam btn">
                                    रक्कम :  {item.work_budget}
                                    </div>}
                                    {item.work_desc && <div className="rakkam btn">
                                      {item.work_desc}
                                    </div>}

                                </div>








                            </AccordionItemPanel>
                        </AccordionItem>
                    ))
                }
            </Accordion>
        </>
    );
}

export default Accordian;
